import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4","key":"svg-0"}],["path",{"d":"M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-1"}],["path",{"d":"M8 11v-3m.719 -3.289a4 4 0 0 1 7.281 2.289v4","key":"svg-2"}],["path",{"d":"M3 3l18 18","key":"svg-3"}]]

const IconLockOff = createReactComponent('outline', 'lock-off', 'LockOff', __iconNode);

export default IconLockOff;